.notesContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.noNotes {
  text-align: center;
  margin: var(--spacingXl) 0;
}
